import { BaseTypeModel } from '../base-type.model';
import { MultiTemplateTransactionalEmailTemplateModel } from "./multi-template-transactional-email-template.model";
import { WhatsAppTemplateParamModel } from "../whatsapp";
import { ReminderConfigModel } from './reminder-config.model';

export interface MultiTemplateTransactionalEmailTypeModel extends BaseTypeModel {
  emailFrom: string;
  emailFromName: string;
  mailServerId?: number | null;
  emailTo: string;
  emailAttachmentFileName: string;

  autoPurge: boolean;
  autoPurgeByDays: number;

  sendSms: boolean;
  smsContent: string;

  passwordProtected: boolean;
  hasAttachment: boolean;
  hasHtmlFile: boolean;
  hasReminder?: boolean;
  hasAcknowledgement?: boolean;
  acknowledgementExpiryDays?: number | null;
  hasCustomAcknowledgeUrl?: boolean;
  customAcknowledgeUrl?: string | null;
  customAcknowledgeUrlSecret?: string | null;
  hasCustomExpiryUrl?: boolean;
  customExpiryUrl?: string | null;
  hasCustomLandingPage?: boolean;
  customSuccessLandingUrl?: string | null;
  customFailLandingUrl?: string | null;
  notificationEmail?: string;

  archive: boolean;

  emailTotal: number;
  emailStatusBounced: number;
  emailStatusBouncedSkip: number;
  emailStatusOpened: number;
  emailStatusSent: number;
  emailStatusUnsubscribed: number;
  emailStatusUnsubscribedSkip: number;
  emailStatusAcknowledge: number;

  whatsAppTemplateName?: string | null;
  whatsAppTemplateParams?: WhatsAppTemplateParamModel[];
  transactionalEmailTemplates: MultiTemplateTransactionalEmailTemplateModel[];
  reminderConfigs?: ReminderConfigModel[];
  isTest?: boolean;
  test?: boolean;
}
